<nz-modal
  nzWrapClassName="vertical-center-modal"
  nzClassName="watchlist-modal-container"
  [(nzVisible)]="visible"
  [nzTitle]="titleTemplate"
  nzWidth="732px"
  (nzOnCancel)="closeModal()"
  [nzFooter]="footer"
>
  <div *nzModalContent>
    <div *ngIf="currentIndex === 1">
      <!-- showCreateEditModal === true instead of currentIndex = 1 -->
      <div class="watchlist-name">
        <div class="input-with-action">
          <input
            #watchlistRename
            id="input_name"
            nz-input
            nzSize="small"
            placeholder="Enter Watchlist Name"
            [(ngModel)]="watchlistName"
            maxlength="50"
            (blur)="onBlurWatchlistName()"
            [ngClass]="[watchistError ? 'err-border' : '']"
            (click)="setEditMode(watchlistRename)"
          />
          <div
            class="save-edit-holder toggle-icon-onhover"
            [class.in-edit-mode]="inEditMode"
            (click)="toggleEditMode(watchlistRename)"
          >
            <va-icon
              isFontAwesome="true"
              [name]="inEditMode ? fasSave : falPencil"
            >
            </va-icon>
            <va-icon
              isFontAwesome="true"
              [name]="inEditMode ? fasSave : falPencil"
            >
            </va-icon>
          </div>
        </div>

        <span
          class="error-color watchlist-name-error"
          [hidden]="watchistError === ''"
        >
          <va-icon
            isFontAwesome="true"
            [name]="faExclamationTriangle"
          ></va-icon>
          {{ watchistError }}</span
        >
      </div>
      <div class="watchlist-tickers">
        <div>
          <app-watchlist-search-add
            [saveTrigger]="saveTrigger"
            [(existingTickers)]="existingTickers"
            (watchListData)="getUpdatedWatchListData($event)"
          ></app-watchlist-search-add>
        </div>
      </div>
    </div>
    <div
      class="finish-screen"
      *ngIf="currentIndex === 2"
      style="text-align: center"
    >
      <!-- showFinishModal === true instead of currentIndex = 2 -->
      <h3 class="header-3">Finish</h3>
      <div>
        <div class="success-icon">
          <va-icon isFontAwesome="true" [name]="faCheckCircle"></va-icon>
        </div>
        <div class="success-msg">
          <p>'{{ watchlistName }}' is successfully saved</p>
          <p>
            Visit
            <a (click)="navigateToWatchlistPage()">My Watchlist Page</a> to
            manage
          </p>
        </div>
      </div>
      <div class="alerts-switch">
        <nz-switch
          nzSize="small"
          [(ngModel)]="enableAlerts"
          (ngModelChange)="onChangeAlertsSwitch($event)"
        ></nz-switch
        ><span> Add <b>Alerts Settings</b> for '{{ watchlistName }}'</span>
      </div>
      <div
        style="
          color: #99a1ad;
          font-size: 10px;
          text-align: left;
          margin: 0px 0 0 32px;
        "
      >
        <va-icon isFontAwesome="true" [name]="faInfoCircle"></va-icon>
        <div style="padding-left: 5px; display: inline-block">
          Visit
          <a (click)="navigateToAlertsPage()">Alerts Settings page</a>
          for details.
        </div>
      </div>
      <app-watchlist-alerts
        [disableAlerts]="!enableAlerts"
        [watchlistId]="watchlistId"
        (alertsData)="getUpdatedAlertsData($event)"
      >
      </app-watchlist-alerts>
    </div>
  </div>
  <ng-template #footer>
    <div class="footer">
      <div *ngIf="currentIndex == 1">
        <div nzType="flex" nzJustify="end">
          <div>
            <button
              *ngIf="invalidCount === 0"
              nz-button
              nzType="primary"
              (click)="onClickSaveWatchlist($event)"
              [nzLoading]="isLoadingSaveWatchlist"
              [disabled]="
                disableSaveWatchlistBtn ? disableSaveWatchlistBtn : null
              "
            >
              <span>Save</span>
            </button>
            <button
              *ngIf="invalidCount !== 0"
              nz-button
              nzType="primary"
              [nzLoading]="isLoadingSaveWatchlist"
              (click)="onClickSaveWatchlist($event)"
              [disabled]="disableIgnoreSaveBtn"
            >
              <span>Remove errors & Save</span>
            </button>
          </div>
        </div>
      </div>
      <div *ngIf="currentIndex == 2">
        <div nz-row nzType="flex" nzJustify="end" nzGutter="12">
          <div nz-col>
            <button
              nz-button
              nzType="default"
              (click)="closeModal()"
              class="watchlist-btn"
            >
              <span>Not Now, Close</span>
            </button>
          </div>
          <div nz-col>
            <button
              nz-button
              nzType="primary"
              (click)="onClickSaveAlerts()"
              [disabled]="!enableAlertsBtn"
              [nzLoading]="isLoadingSaveAlerts"
            >
              <span>Save Alert Settings</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <nz-modal
      nzWrapClassName="vertical-center-modal"
      [(nzVisible)]="isVisibleConfirmModal"
      nzTitle=""
      (nzOnCancel)="handleConfirmModalCancel()"
      [nzFooter]="confirmModalFooter"
      [nzClassName]="'restart-modal'"
      nzWidth="450"
    >
      <ng-container *nzModalContent>
        <div class="icon-col">
          <va-icon
            isFontAwesome="true"
            [name]="faExclamationTriangle"
            class="error-color caution-icon"
          ></va-icon>
        </div>
        <div class="text-col">
          <h3 class="header-4">Caution!</h3>
          <p>
            If you click Close, any ticker information you entered will be lost.
          </p>
        </div>
      </ng-container>
      <ng-template #confirmModalFooter>
        <div
          nz-row
          nzType="flex"
          nzJustify="end"
          [nzGutter]="8"
          class="confirm-modal-footer"
        >
          <div nz-col>
            <va-button
              btnType="outline"
              size="medium"
              (click)="handleConfirmModalCancel()"
              class="watchlist-btn"
            >
              Cancel
            </va-button>
          </div>
          <div nz-col>
            <va-button
              btnType="solid"
              size="medium"
              state="error"
              (click)="onClickWarningSubmit()"
            >
              Close
            </va-button>
          </div>
        </div>
      </ng-template>
    </nz-modal>
  </ng-template>

  <ng-template #titleTemplate>
    <span *ngIf="modalTitle"> {{ modalTitle }} </span>
    <span *ngIf="!modalTitle">Create Watchlist</span>
  </ng-template>
</nz-modal>
